import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'split-line-with-button',
  templateUrl: './line-with-button.component.html',
  styleUrls: ['./line-with-button.component.scss'],
})
export class LineWithButtonComponent {
  @Input() title: string = 'Título Padrão';
  @Input() selected: boolean = false;
  @Output() select = new EventEmitter<void>();

  onSelect() {
    this.select.emit();
  }
}
